import React, { FC, useEffect, useRef } from 'react'
import { InputComponent, InputProps } from 'LibNeo'
import { FieldNames } from 'Src/constants/FieldNames'
import { onFocusQuotes } from 'Helpers'
import { Callback } from 'Types/utilTypes'
import { Validators } from 'Modules'
import { isLatinFields, translateOptions } from 'Pages/registratorCabinet'

interface ComponentProps extends InputProps {
	required: boolean
	initialValue: string
}

export const QuotesInput: FC<ComponentProps> = (props) => {
	const { required, initialValue, form, fieldName, onChange } = props
	const inputRef = useRef<{ input: HTMLInputElement }>(null)

	const isLatin = isLatinFields.includes(fieldName as FieldNames)

	const onFocus = onFocusQuotes({
		form,
		fieldName,
		onChange,
		ref: inputRef,
	})

	const onBlur: Callback = () => {
		const reg_space = /"\s*([^"]*?)\s*"/g
		let value = form.getFieldValue(fieldName)
		if (value === '""') value = ''
		value = (value ?? '')
			.trim()
			.replace(/\s\s+/g, ' ')
			.replace(/"(\s|")*"/g, '"')
		if (value?.match(reg_space)) value = value.replace(reg_space, '"$1"')
		form?.setFieldsValue({ [fieldName]: value })
		form.validateFields([fieldName])
	}

	useEffect(() => {
		form.validateFields([fieldName], { force: true })
	}, [form.getFieldValue(fieldName)])

	return (
		<>
			<InputComponent
				{...props}
				getInputRef={inputRef}
				fieldName={fieldName}
				type="text"
				fieldOptions={{
					initialValue,
					rules: [
						{
							validator: Validators.checkCyrillicOrLatinQuotes({
								required,
								payload: {
									isLatin,
								},
							}),
						},
					],
				}}
				helpText={`${translateOptions[fieldName]} ${
					form?.getFieldValue(fieldName)
						? `${form?.getFieldValue(fieldName)}
`
						: ''
				}`}
				onFocus={onFocus}
				onBlur={onBlur}
			/>
		</>
	)
}
